import styled from "styled-components";

const KanbanAccordionCardContainer = styled.div`
  width: 100%;

  .accordionComponent {
    margin-bottom: 15px;
    border-radius: 10px;
    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 25%);
    overflow: hidden;
    &:before {
      display: none;
    }
  }

  .MuiAccordionSummary-content {
    padding-top: 15px;
    padding-bottom: 15px;
    overflow: hidden;
  }

  .css-o4b71y-MuiAccordionSummary-content.Mui-expanded {
    margin: 12px 0;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .css-1elwnq4-MuiPaper-root-MuiAccordion-root.Mui-expanded:last-of-type {
    margin-bottom: 15px;
  }
`;

export { KanbanAccordionCardContainer };
